import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import Row from 'blocks/Row';
import { PageTitle } from 'blocks/Text';
import { TextField } from 'components/Form';
import WithSidebar from 'layouts/WithSidebar';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
import ChatBox from '../components/ChatBox';
import { CreateTicketFormModel } from '../ticket.interface';
import * as S from './create.styles';

const CreateTicket: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { register, getValues } = useForm<CreateTicketFormModel>();

  const onSend = async (body) => {
    const res = await ajax({
      url: urls.tickets,
      method: 'POST',
      data: {
        subject: getValues('subject'),
        mainContent: body,
      },
    });

    if (!res) return;

    navigate(`/tickets/${res.id}`);
  };

  return (
    <WithSidebar>
      <S.Wrapper>
        <BoxWrapper>
          <Row justify="space-between">
            <PageTitle>{t('pages.tickets.create.title')}</PageTitle>
            <Button type="button" onClick={() => navigate(-1)}>
              {t('pages.tickets.create.returnToListCTA')}
            </Button>
          </Row>
        </BoxWrapper>
        <BoxWrapper>
          <Card>
            <TextField control={register('subject')} label={t('pages.tickets.create.form.fields.subject.label')} />
          </Card>
        </BoxWrapper>
        <S.ChatBox as={BoxWrapper}>
          <ChatBox chatList={[]} onSend={onSend} />
        </S.ChatBox>
      </S.Wrapper>
    </WithSidebar>
  );
};

export default CreateTicket;
